import { ruleAssessmentsTabContent } from '../../constants/rule-assessments.constant';
import { RuleAssessmentMessage } from './rule-assessment-message';

export const RuleAssessmentNotFound = (): JSX.Element => (
  <RuleAssessmentMessage
    title={ruleAssessmentsTabContent.notFoundTitle}
    body={ruleAssessmentsTabContent.notFoundBody}
  />
);
